import React from 'react';
import { connect } from 'react-redux';
import { gql } from 'apollo-boost';
import { Query } from 'react-apollo';
import Spinner from '~/components/spinner/spinner';
import LocationDetailCard from '~/components/locationDetailCard/locationDetailCard';
import NotesCard from '~/components/notesCard/notesCard';
import ErrorBoundaryContent from '~/components/errorBoundary/content';

export const getLocationQuery = gql`
  query location($id: Int!) {
    location(id: $id) {
      id
      name
      notes
    }
  }
`;

const Location = ({ onCompleted, id }) => (
  <Query query={getLocationQuery} variables={{ id }} onCompleted={onCompleted} fetchPolicy={'cache-and-network'}>
    {props => {
      const { loading, error, data } = props;
      if (loading) {
        return <Spinner className="absolute absolute-center stroke-brand-red" />;
      }

      if (error) {
        return <ErrorBoundaryContent error={error} />;
      }

      const { location } = data;
      return (
        <div className="flex content">
          <div className="flex-2 mr4">
            <LocationDetailCard className="mb4" {...location} />
          </div>
          <div className="flex-1">
            <NotesCard notes={location.notes} />
          </div>
        </div>
      );
    }}
  </Query>
);

function mapStateToProps(state) {
  return {
    brewery: state.brewery
  };
}

export default connect(mapStateToProps)(Location);



// WEBPACK FOOTER //
// ./src/containers/location/location.jsx